import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRepeatable = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M17.759 8.421a6.964 6.964 0 1 0 .488 6.327l1.879.786a9 9 0 1 1-.652-8.211l.811-2.83 1.72.494-1.726 6.018-6.018-1.726.493-1.72 3.005.862z"
	})
});
export default SvgRepeatable;
